<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
        <h1 class="page-title fw-bold">Validation des Météos</h1>
        <div>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de bord</a></router-link></li>
                <li class="breadcrumb-item" aria-current="page"><router-link :to="{ name: 'composantes', params: { showList: true }}"><a>Portefeuille</a></router-link></li>
                <li class="breadcrumb-item active" aria-current="page"><router-link :to="{ name: 'validationMeteos' }"><a>Validation des Météos</a></router-link></li>
            </ol>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12" v-if="showList">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title fw-bold">Liste des météos à valider</h3>
                    <div class="card-options">
                        <SearchInputAll></SearchInputAll>
                        <button class="btn btn-outline-dark mx-5" @click="sentBackPortefeuille"><span class="fe fe-arrow-left-circle"></span> Retour sur Portefeuille</button>
                    </div>
                </div>
                <div class="card-body pt-4">
                    <div class="grid-margin">
                        <div class="panel panel-primary">
                            <div class="panel-body tabs-menu-body border-2 pt-0">
                                <nav>
                                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                        <a class="nav-item nav-link active" id="nav-contact-tab" @click="runCheck(0, $event)" data-toggle="tab" href="#nav-0" role="tab"
                                            aria-controls="nav-0" aria-selected="false">Non Validés</a>
                                        <!-- <a class="nav-item nav-link" id="nav-home-tab" data-toggle="tab" @click="runCheck(1, $event)" href="#nav-1" role="tab"
                                            aria-controls="nav-1" aria-selected="true">Non Validés</a> -->
                                        <!-- <a class="nav-item nav-link" id="nav-home-tab" data-toggle="tab" @click="runCheck(2, $event)" href="#nav-2" role="tab"
                                            aria-controls="nav-2" aria-selected="true">Validés</a> -->
                                    </div>
                                </nav>
                                <div class="tab-content">
                                    <div class="tab-pane active" id="nav-0" role="tabpanel" aria-labelledby="nav-0-tab">
                                        <div class="table-responsive">
                                            <table class="table table-hover table-bordered text-nowrap mb-0">
                                                <thead class="border-top success02">
                                                    <tr>
                                                        <th class="bg-transparent border-bottom-0 fw-bold text-center"
                                                            style="width: 5%;">Validation</th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                                            style="width: 5%;">Actions</th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                                            @click="sortBy('composante')"> Composante
                                                        </th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                                            @click="sortBy('declaredAt')">Date déclaration
                                                        </th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                                            @click="sortBy('meteo')">Météo
                                                        </th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                                            @click="sortBy('etudes')">Etudes
                                                        </th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                                            @click="sortBy('gouvernance')">Gouvernance
                                                        </th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                                            @click="sortBy('contrat')">Contrat
                                                        </th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                                            @click="sortBy('execution')">Exécution
                                                        </th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                                            @click="sortBy('miseEnService')">Mise en service
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="filtersItems[0]" id="myTable1">
                                                    <tr v-for="(item, index) in filtersItems" :key="index" class="border-bottom">
                                                        <td class="text-center" :class="item?.validated ? 'bg-gray' : ''">
                                                            <input type="checkbox" class="form-check-input" :value="item.id" v-model="listIdValidation" v-if="!item?.validated" />
                                                        </td>
                                                        <td class="text-center" :class="item?.validated ? 'bg-gray' : ''">
                                                            <button v-if="!item?.validated"
                                                                class="btn text-danger btn-sm" @click.prevent="drop(item)"
                                                                    data-bs-toggle="tooltip" title="Supprimer"
                                                                    data-bs-original-title="Delete"><span
                                                                        class="fe fe-trash-2 fs-18"></span></button>
                                                        </td>
                                                        <td>{{ item?.idComposante?.idComposante }} - {{ item?.idComposante?.nomComposante }}</td>
                                                        <td>{{ item?.declaredAt | moment('DD-MM-YYYY HH:mm') }}</td>
                                                        <td class="text-center" :style="'background-color: '+ couleurMeteo(item?.couleur)">
                                                            <small class="fw-bold">{{ item?.couleur ? item?.couleur : 'Blanc' }}</small>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="d-inline-block rounded-circle" :style="{
                                                                backgroundColor: couleurCritere(item?.etudes), width: '30px', height: '30px', border: '1px solid #000000',
                                                                }" :title="item?.etudes ? item?.etudes : 'Non renseigné'"></span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="d-inline-block rounded-circle" :style="{
                                                                backgroundColor: couleurCritere(item?.gouvernance), width: '30px', height: '30px', border: '1px solid #000000',
                                                                }" :title="item?.gouvernance ? item?.gouvernance : 'Non renseigné'"></span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="d-inline-block rounded-circle" :style="{
                                                                backgroundColor: couleurCritere(item?.contrat), width: '30px', height: '30px', border: '1px solid #000000',
                                                                }" :title="item?.contrat ? item?.contrat : 'Non renseigné'"></span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="d-inline-block rounded-circle" :style="{
                                                                backgroundColor: couleurCritere(item?.execution), width: '30px', height: '30px', border: '1px solid #000000',
                                                                }" :title="item?.execution ? item?.execution : 'Non renseigné'"></span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="d-inline-block rounded-circle" :style="{
                                                                backgroundColor: couleurCritere(item?.miseEnService), width: '30px', height: '30px', border: '1px solid #000000',
                                                                }" :title="item?.miseEnService ? item?.miseEnService : 'Non renseigné'"></span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr class="primary02">
                                                        <td colspan="10" class="text-center">Aucune météo trouvée.</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <paginate :records="items.totalElements || 0" v-model="items.number" :per-page="items.size"
                                                :options="{ theme: 'bootstrap4', edgeNavigation: true, texts: { count: `{from} à {to} de {count} éléments|{count} éléments|Un élément`, first: '<<<', last: '>>>' } }"
                                                @paginate="onSearch" />
                                        <div class="text-center mt-3">
                                            <button type="button" @click.prevent="validationMeteo(listIdValidation)"
                                                class="btn btn-outline-success mr-4" :disabled="listIdValidation.length === 0">
                                                <i class="fe fe-check-circle"></i> Valider les météos</button>
                                            <!-- <button type="button" @click.prevent="show(listIdValidation)" class="btn btn-outline-danger mr-4"
                                                :disabled="listIdValidation.length === 0">
                                                <i class="fa fa-minus"></i> Rejeter les liquidations</button> -->
                                        </div>
                                    </div>

                                    <!-- <div class="tab-pane" id="nav-1" role="tabpanel" aria-labelledby="nav-1-tab">
                                        <div class="table-responsive">
                                            <div class="table-responsive">
                                                <table class="table table-hover table-bordered text-nowrap mb-0">
                                                    <thead class="border-top success02">
                                                        <tr>
                                                            <th class="bg-transparent border-bottom-0 fw-bold text-center"
                                                                style="width: 5%;">Validation</th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                style="width: 5%;">Actions</th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('composante')"> Composante
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('declaredAt')">Date déclaration
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('meteo')">Météo
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('etudes')">Etudes
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('gouvernance')">Gouvernance
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('contrat')">Contrat
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('execution')">Exécution
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('miseEnService')">Mise en service
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody v-if="filtersItems.length > 0" id="myTable1">
                                                        <tr v-for="(item, index) in filtersItems" :key="index" class="border-bottom">
                                                            <td class="text-center">
                                                                    <input type="checkbox" class="form-check-input" :value="item.id" v-model="listIdValidation" />
                                                            </td>
                                                            <td class="text-center">
                                                                    <button
                                                                        class="btn text-danger btn-sm" @click.prevent="drop(item)"
                                                                            data-bs-toggle="tooltip" title="Supprimer"
                                                                            data-bs-original-title="Delete"><span
                                                                                class="fe fe-trash-2 fs-18"></span></button>
                                                            </td>
                                                            <td>{{ item?.idComposante?.idComposante }} - {{ item?.idComposante?.nomComposante }}</td>
                                                            <td>{{ item?.declaredAt | moment('DD-MM-YYYY HH:mm') }}</td>
                                                            <td class="text-center" :style="'background-color: '+ couleurMeteo(item?.couleur)">
                                                                <small class="fw-bold">{{ item?.couleur ? item?.couleur : 'Blanc' }}</small>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.etudes), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.etudes ? item?.etudes : 'Non renseigné'"></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.gouvernance), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.gouvernance ? item?.gouvernance : 'Non renseigné'"></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.contrat), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.contrat ? item?.contrat : 'Non renseigné'"></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.execution), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.execution ? item?.execution : 'Non renseigné'"></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.miseEnService), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.miseEnService ? item?.miseEnService : 'Non renseigné'"></span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody v-else>
                                                        <tr class="primary02">
                                                            <td colspan="10" class="text-center">Aucune météo trouvée.</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <nav class="mt-2">
                                                <ul class="pagination justify-content-end">
                                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                                        <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">&laquo;</a>
                                                    </li>
                                                    <li v-for="page in pageCount" :key="page" class="page-item" :class="{ active: currentPage === page }">
                                                        <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                                                    </li>
                                                    <li class="page-item" :class="{ disabled: currentPage === pageCount }">
                                                        <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">&raquo;</a>
                                                    </li>
                                                </ul>
                                            </nav>
                                            <div class="text-center mt-3">
                                                <button type="button" @click.prevent="validationMeteo(listIdValidation)"
                                                    class="btn btn-outline-success mr-4" :disabled="listIdValidation.length === 0">
                                                    <i class="fe fe-check-circle"></i> Valider les météos</button>
                                            </div>
                                        </div>
                                    </div> -->

                                    <!-- <div class="tab-pane" id="nav-2" role="tabpanel" aria-labelledby="nav-2-tab">
                                        <div class="table-responsive">
                                            <div class="table-responsive">
                                                <table class="table table-hover table-bordered text-nowrap mb-0">
                                                    <thead class="border-top success02">
                                                        <tr>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('composante')"> Composante
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('declaredAt')">Date déclaration
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('meteo')">Météo
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('etudes')">Etudes
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('gouvernance')">Gouvernance
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('contrat')">Contrat
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('execution')">Exécution
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('miseEnService')">Mise en service
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody v-if="filtersItems.length > 0" id="myTable1">
                                                        <tr v-for="(item, index) in filtersItems" :key="index" class="border-bottom">
                                                            <td>{{ item?.idComposante?.idComposante }} - {{ item?.idComposante?.nomComposante }}</td>
                                                            <td>{{ item?.declaredAt | moment('DD-MM-YYYY HH:mm') }}</td>
                                                            <td class="text-center" :style="'background-color: '+ couleurMeteo(item?.couleur)">
                                                                <small class="fw-bold">{{ item?.couleur ? item?.couleur : 'Blanc' }}</small>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.etudes), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.etudes ? item?.etudes : 'Non renseigné'"></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.gouvernance), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.gouvernance ? item?.gouvernance : 'Non renseigné'"></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.contrat), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.contrat ? item?.contrat : 'Non renseigné'"></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.execution), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.execution ? item?.execution : 'Non renseigné'"></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.miseEnService), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.miseEnService ? item?.miseEnService : 'Non renseigné'"></span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody v-else>
                                                        <tr class="primary02">
                                                            <td colspan="10" class="text-center">Aucune météo trouvée.</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <nav class="mt-2">
                                                <ul class="pagination justify-content-end">
                                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                                        <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">&laquo;</a>
                                                    </li>
                                                    <li v-for="page in pageCount" :key="page" class="page-item" :class="{ active: currentPage === page }">
                                                        <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                                                    </li>
                                                    <li class="page-item" :class="{ disabled: currentPage === pageCount }">
                                                        <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">&raquo;</a>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="detail-composante-meteo" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-primary text-white">
                            <h6 class="modal-title fw-bold" style="font-size: 16px;">Historique des météos de la composante sélectionnée</h6><button aria-label="Close" class="btn-close text-white"
                                data-bs-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <ul class="row p-3">
                                <li class="col-lg-12 mb-2">
                                    <h4 class="fw-bold">Composante : {{ composante?.idComposante }} --- {{ composante?.nomComposante }}</h4>
                                </li>
                                <li class="col-lg-12 mb-2">
                                    <table class="table table-hover table-bordered">
                                        <thead class="border-top success02">
                                            <tr>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Date déclaration
                                                </th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Météo
                                                </th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Etudes
                                                </th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Gouvernance
                                                </th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Contrat
                                                </th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Exécution
                                                </th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Mise en service
                                                </th>
                                                <th class="bg-transparent border-bottom-0 fw-bold"
                                                    style="width: 5%;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="meteos.length > 0" id="myTable1">
                                            <tr v-for="(item, index) in meteos" :key="index" class="border-bottom">
                                                <td>{{ item?.declaredAt | moment('DD-MM-YYYY HH:mm') }}</td>
                                                <td class="text-center" :style="'background-color: '+ couleurMeteo(item?.couleur)">
                                                    <small class="fw-bold">{{ item?.couleur ? item?.couleur : 'Blanc' }}</small>
                                                </td>
                                                <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(item?.etudes), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="item?.etudes ? item?.etudes : 'Non renseigné'"></span>
                                                </td>
                                                <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(item?.gouvernance), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="item?.gouvernance ? item?.gouvernance : 'Non renseigné'"></span>
                                                </td>
                                                <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(item?.contrat), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="item?.contrat ? item?.contrat : 'Non renseigné'"></span>
                                                </td>
                                                <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(item?.execution), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="item?.execution ? item?.execution : 'Non renseigné'"></span>
                                                </td>
                                                <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(item?.miseEnService), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="item?.miseEnService ? item?.miseEnService : 'Non renseigné'"></span>
                                                </td>
                                                <td class="text-center">
                                                    <div class="g-2 d-flex">
                                                        <button class="btn text-primary btn-sm" @click.prevent="edit(item)"
                                                            data-bs-toggle="tooltip" title="Modifier"
                                                            data-bs-original-title="Edit"><span
                                                                class="fe fe-edit fs-18"></span></button>
                                                        <button
                                                            class="btn text-danger btn-sm" @click.prevent="drop(item)"
                                                                data-bs-toggle="tooltip" title="Supprimer"
                                                                data-bs-original-title="Delete"><span
                                                                    class="fe fe-trash-2 fs-18"></span></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr class="primary02">
                                                <td colspan="8" class="text-center">Aucune météo trouvée.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </li>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-gray" data-bs-dismiss="modal">Fermer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- COL END -->
         <div class="row" v-else>
            <div class="col-sm-12 col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Création d'une météo</h3>
                    </div>
                    <ValidationObserver v-slot="{ invalid }">
                        <form @submit.prevent="submit">
                            <div class="card-body d-flex">
                                <div class="col-md-6 mx-auto">
                                    <div class="form-row">
                                        <div class="form-group col-md-12">
                                            <ValidationProvider name="idComposante" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Composante <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.idComposante" deselect-label="Sélectionné" select-label="" :options="composantes"
                                                                placeholder="Sélectionné la composante" label="nomComposante" track-by="idComposante" :searchable="true"
                                                                :custom-label="o => o.idComposante + ' - ' + o.nomComposante" @select="selectComposante(payload.idComposante)">
                                                    <template slot="singleLabel" slot-scope="{ option }">
                                                        <strong> {{ option.nomComposante }}</strong>
                                                    </template>
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="etatComposante" rules="" v-slot="{ errors }">
                                                <label class="form-label">Etat ou Implication ASIN </label>
                                                <!-- <multi-select v-model="payload.idComposante.etatComposante" deselect-label="Sélectionné" select-label="" :options="etatComposantes"
                                                                placeholder="Sélectionné l'état de la composante" label="libelle" track-by="etat" 
                                                                :searchable="true" readonly>
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select> -->
                                                <input type="hidden" name="etatComposante" v-model="payload.idComposante.etatComposante.etat" />
                                                <input type="text" name="etatComposanteLibelle" v-model="payload.idComposante.etatComposante.libelle" id="etatComposante" class="form-control" readonly />
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="tepGlobal" rules="min_value:0|max_value:100" v-slot="{ errors }">
                                                <label class="form-label">TEP Global (%) </label>
                                                <input type="text" name="tepGlobal" v-model="payload.idComposante.tepGlobal" id="tepGlobal" class="form-control" readonly />
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-12 mb-0">
                                            <ValidationProvider name="declaredAt" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Déclarer le <span class="text-danger">*</span></label>
                                                <date-pick :language="fr" :bootstrapStyling="true" minimumView="day" name="declaredAt"
                                                        v-model="payload.declaredAt" placeholder="Sélectionnez une date" :disabled="true"
                                                        calendar-button-icon="fe fe-calendar" @input="verifyCouleur(payload)" />
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-10 mb-0">
                                            <ValidationProvider name="etudes" rules="min_value:0|max_value:3" v-slot="{ errors }">
                                                <label class="form-label">Etudes </label>
                                                <input type="text" class="form-control" name="etudes" id="etudes" v-model="payload.etudes" 
                                                placeholder="saisir la pondération du critère..." @change="verifyCouleur(payload)">
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-md-2 mb-0 mt-6">
                                            <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(payload?.etudes), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="payload?.etudes ? payload?.etudes : 'Non renseigné'"></span>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-10 mb-0">
                                            <ValidationProvider name="gouvernance" rules="min_value:0|max_value:3" v-slot="{ errors }">
                                                <label class="form-label">Gouvernance </label>
                                                <input type="text" class="form-control" name="gouvernance" id="gouvernance" v-model="payload.gouvernance" 
                                                placeholder="saisir la pondération du critère..." @change="verifyCouleur(payload)">
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-md-2 mb-0 mt-6">
                                            <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(payload?.gouvernance), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="payload?.gouvernance ? payload?.gouvernance : 'Non renseigné'"></span>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-10 mb-0">
                                            <ValidationProvider name="contrat" rules="min_value:0|max_value:3" v-slot="{ errors }">
                                                <label class="form-label">Contrat </label>
                                                <input type="text" class="form-control" name="contrat" id="contrat" v-model="payload.contrat" 
                                                @change="verifyCouleur(payload)" placeholder="saisir la pondération du critère...">
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-md-2 mb-0 mt-6">
                                            <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(payload?.contrat), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="payload?.contrat ? payload?.contrat : 'Non renseigné'"></span>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-10 mb-0">
                                            <ValidationProvider name="execution" rules="min_value:0|max_value:3" v-slot="{ errors }">
                                                <label class="form-label">Exécution </label>
                                                <input type="text" class="form-control" name="execution" id="execution" v-model="payload.execution" 
                                                @change="verifyCouleur(payload)" placeholder="saisir la pondération du critère...">
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-md-2 mb-0 mt-6">
                                            <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(payload?.execution), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="payload?.execution ? payload?.execution : 'Non renseigné'"></span>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-10 mb-0">
                                            <ValidationProvider name="miseEnService" rules="min_value:0|max_value:3" v-slot="{ errors }">
                                                <label class="form-label">Mise en service </label>
                                                <input type="text" class="form-control" name="miseEnService" id="miseEnService" v-model="payload.miseEnService" 
                                                @change="verifyCouleur(payload)" placeholder="saisir la pondération du critère...">
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-md-2 mb-0 mt-6">
                                            <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(payload?.miseEnService), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="payload?.miseEnService ? payload?.miseEnService : 'Non renseigné'"></span>
                                        </div>
                                    </div>
                                    <!-- <div class="form-row">
                                        <div class="form-group col-md-12 mb-0">
                                            <ValidationProvider name="meteo" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Météo <span class="text-danger">*</span></label>
                                                <input type="text" class="form-control" name="meteo" id="meteo" v-model="payload.meteo" placeholder="saisir la météo">
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div> -->
                                    <div class="form-row">
                                        <div class="form-group col-md-12 mb-0">
                                            <ValidationProvider name="commentaire" rules="" v-slot="{ errors }">
                                                <label class="form-label">Commentaire</label>
                                                <!-- <input type="text" class="form-control" id="commentaire" v-model="payload.commentaire" placeholder="saisir la météo"> -->
                                                <textarea name="commentaire" v-model="payload.commentaire" class="form-control" id="commentaire" rows="3"></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-footer mt-2">
                                        <button type="button" class="btn btn-primary mt-4 mb-0" @click="sentBack">
                                            Retour
                                        </button>
                                        <button class="btn btn-success mt-4 mb-0 mx-5" :disabled="invalid" v-if="save"><span class="fe fe-check"></span> Enregistrer</button>
                                        <button class="btn btn-success mt-4 mb-0 mx-5" :disabled="invalid" v-else><span class="fe fe-check"></span> Modifier</button>
                                    </div>
                                </div>
                                <div class="col-md-6 mx-auto my-auto">
                                    <div class="form-row">
                                        <div class="form-group col-md-12 mb-0 text-center">
                                            <label class="form-label">Couleur</label>
                                            <span class="d-inline-block rounded-circle"
                                                :style="{
                                                backgroundColor: couleurMeteo(payload.couleur),
                                                width: '150px',
                                                height: '150px',
                                                border: '1px solid #000000',
                                                }"
                                                :title="payload.couleur ? payload.couleur : 'Blanc'"
                                            ></span>
                                            <br><span class="align-middle">{{ payload.couleur ? payload.couleur : 'Blanc' }}</span>
                                            <input type="hidden" name="couleur" id="couleur" v-model="payload.couleur" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
            </div>
         </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { reduce } from "lodash";
import * as lang from "vuejs-datepicker/src/locale";
import Composantes from './Composantes.vue';
export default {
    name: "Meteo",
    data() {
        return {
            lang: lang, loading: false, showList: true,
            payload: {etudes: '', gouvernance: '', contrat: '', execution: '', miseEnService: '', declaredAt: new Date(), idComposante: {}, 
            couleur: '', commentaire: '', nbCriteres: '', score: '', idTypeMeteo: {},}, save: true,
            composantes: [], classeurs: [], classeur: {}, lesComposantes: [], composante: {}, meteos: [], etatComposantes: [], statutComposantes: [],
            meteoEvaluer: {}, listIdValidation: [], lesmeteos: [],
            currentPage: 1,
            perPage: 10,
            currentSort: 'composante',
            currentSortDir: 'asc'
        }
    },
    computed: {
        ...mapGetters({ items: 'operation/meteoList' }),
        //...mapGetters({ items: 'composantes/list' }),
        sortedItems() {
            if (this.lesmeteos && this.lesmeteos.length > 0) {
                this.lesmeteos = this.lesmeteos    
            }else{
                this.lesmeteos = this.items
            }
            return this.lesmeteos.sort((a, b) => {
                const aVal = this.resolveSortValue(a);
                const bVal = this.resolveSortValue(b);
                if (this.currentSortDir === 'asc') {
                return aVal > bVal ? 1 : -1;
                } else {
                return aVal < bVal ? 1 : -1;
                }
            });
        },
        fr() {
          return this.lang.fr;
        },
        filtersItems() {
            // const start = (this.currentPage - 1) * this.perPage;
            // return this.sortedItems.slice(start, start + this.perPage);
            if (this.lesmeteos && this.lesmeteos.length > 0) {
                this.lesmeteos = this.lesmeteos;
            }else{
                this.lesmeteos = this.items?.content;
            }
            return this.lesmeteos || [];
        },
        pageCount() {
            return Math.ceil(this.items.length / this.perPage);
        },
    },
    methods:{
        ...mapActions('meteo', ['all', 'add']),
        ...mapActions('operation', ['fetchMeteoNotValidated']),
        sortBy(column) {
            if (this.currentSort === column) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSort = column;
                this.currentSortDir = 'asc';
            }
        },
        changePage(page) {
            if (page >= 1 && page <= this.pageCount) {
                this.currentPage = page;
            }
        },
        resolveSortValue(item) {
            const val = item[this.currentSort];
            if (this.currentSort === 'composante') {
                return item.idComposante?.idComposante + ' - ' + item.idComposante?.nomComposante;
            }
            return typeof val === 'string' ? val.toLowerCase() : val;
        },
        initPayload() {
            return this.payload = {etudes: '', gouvernance: '', contrat: '', execution: '', miseEnService: '', declaredAt: new Date(), idComposante: {}, 
            couleur: '', commentaire: '', nbCriteres: '', score: '', idTypeMeteo: {},};
        },
        showForm() {
            this.save = true;
            this.initPayload();
            this.showList = false;
        },
        showFormMeteo(item) {
            this.payload.idComposante = {...item};
            this.save = true;
            this.showList = false;
        },
        sentBack() {
            this.showList = true;
            this.initPayload();
            this.onSearch();
        },
        sentBackMeteos() {
            this.$router.push({ name: 'meteos' });
        },
        sentBackPortefeuille(){
            this.$router.push({ name: 'composantes', params: { showList: true }})
        },
        onSearch(offset) {
            this.$loading(true);
            if (offset > 0) this.option.page = offset - 1;
            //this.$router.push({ query: this.option }).catch(() => { });
            this.fetchMeteoNotValidated(this.option).finally(() => this.$loading(false));
        },
        submit(){
            this.$loading(true);
            this.loading = true;
            if(this.save){
                console.log(this.payload);
                this.$http.post('/meteo', this.payload)
                .then(({data}) => {
                    if (data) {
                        swal('Information!', 'Météo enregistrée avec succès.', 'success');
                        this.onSearch();
                        this.initPayload();
                        this.showList = true;                            
                    } else {
                        swal('Information!', 'L\'enregistrement de la météo n\'a pas pu être effectuée.', 'error');
                    }
                })
                .catch((error) => {
                    swal('Information!', 'Une erreur est survenue lors de l\'enregistrement. ' + error, 'warning');
                })
                .finally(() => this.$loading(false));
            }else{
                console.log("Editer", this.payload);
                this.$http.put('/meteo/' + this.payload.id, this.payload)
                .then(({data}) => {
                    if (data) {
                        swal('Information!', 'Météo modifiée avec succès.', 'success');
                        this.onSearch();
                        this.initPayload();
                        this.showList = true;
                    } else {
                        swal('Information!', 'La modification de la météo n\'a pas pu être effectuée.', 'error');
                    }
                })
                .catch((error) => {
                    swal('Information!', 'Une erreur est survenue lors de la modification. ' + error, 'warning');
                })
                .finally(() => this.$loading(false));
            }
        },
        edit(value){
            this.$loading(true);
            this.save = false;
            this.payload = {...value};
            this.hideModal1();
            this.showForm();
            this.$loading(false);
        },
        drop(item){
            const self = this;
            swal({
                title: "Confirmation",
                text: "Etes-vous sûr de vouloir supprimer la météo ?",
                type: "warning",
                showCancelButton: true,
                closeOnConfirm: false,
                cancelButtonText: "Annuler",
                confirmButtonText: "Supprimer",
                confirmButtonColor: "#7db0b2",
                cancelButtonColor: "#FF0000",
                showLoaderOnConfirm: true
            }, function(result) {
                if (result === true) {
                    self.$loading(true);
                    self.$http.delete('/meteo/' + item.id)
                    .then(({data}) => {
                        swal('Information!', 'Météo supprimée avec succès.', 'success');
                        self.onSearch();
                        self.showList = true;
                    })
                    .catch((error) => {
                        swal('Information!', 'Une erreur est survenue lors de la suppression. ' + error, 'warning');
                    })
                    .finally(() => self.$loading(false));
                }
            });
        },
        statusRetardFdr(value) {
            switch (value) {
                case 'Non':
                    return 'success';
                case 'Oui':
                    return 'danger';
                default:
                    return 'danger'; //PROCESSED
            }
        },
        statusEtat(value) {
            switch (value) {
                case 'SUSPENDU':
                    return '#000000';
                case 'ANNULE':
                    return '#000000';
                case 'ACTIF':
                    return '#C6E0B4';
                case 'CLOTURE':
                    return '#8EA9DB';
                case 'DOUBLON':
                    return '#F2F2F2';
                case 'PLANIFIE':
                    return '#F2F2F2';
                case 'A_SUPPRIMER':
                    return '#F2F2F2';
                case 'NON_DEMARRE':
                    return '#F2F2F2';
                case 'A_CONFIRMER':
                    return '#F2F2F2';
                case 'PLUS':
                    return '#F2F2F2';
                case 'X':
                    return '#F2F2F2';
                case 'NA':
                    return '#F2F2F2';
                default:
                    return '#F2F2F2'; //PROCESSED
            }
        },
        statusStatut(value) {
            switch (value) {
                case '00':
                    return '#F2F2F2';
                case '01':
                    return '#E2EFDA';
                case '02':
                    return '#C6E0B4';
                case '03':
                    return '#8EA9DC';
                case '04':
                    return '#ACB9CA';
                default:
                    return '#F2F2F2'; //PROCESSED
            }
        },
        handleStatut(value){
            console.log(value);
            switch (value.statut) {
                case '00': // A planifier
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'INACTIF');
                    break;
                case '01': // Planifié
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'ACTIF');
                    break;
                case '02': // En cours
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'ACTIF');
                    break;
                case '03': // Terminé
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'CLOTURE');
                    break;
                case '04': // Annulé
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'INACTIF');
                    break;
                default: // A planifier
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'INACTIF');
                    break;
            }  
        },
        hideModal1() {
            $('#detail-composante-meteo').modal('hide');
        },
        showHistoriqueMeteo(item){
            this.$loading(true);
            this.composante = {...item};
            this.$http.get(`/meteo/composante/${item.idComposante}`)
            .then(({data}) =>{
                if (data.length > 0) {
                    this.meteos = data;
                    this.composante = item;
                    $('#detail-composante-meteo').modal('show');
                } else {
                    this.meteos = [];
                    swal('Information!', 'Aucune météo disponible pour cette composante.', 'warning');
                }
            })
            .catch((error) => {
                swal('Information!', 'Erreur lors du chargement des météos : ' + error, 'error');
                console.error('Erreur lors du chargement des météos :', error);
            })
            .finally(() => {
                this.$loading(false);
            });
        },
        verifyCouleur(item){
            this.$loading(true);
            console.log(item);
            var etudes = item.etudes || -1;
            var gouvernance = item.gouvernance || -1;
            var contrat = item.contrat || -1;
            var execution = item.execution || -1;
            var miseEnService = item.miseEnService || -1;
            this.$http.get(`/meteo/evaluerMeteo/${etudes}/${gouvernance}/${contrat}/${execution}/${miseEnService}/${item.idComposante?.etatComposante?.etat}/${item.idComposante?.tepGlobal}`)
            .then(({data}) =>{
                if (data) {
                    this.meteoEvaluer = data;
                    this.payload.idTypeMeteo = this.meteoEvaluer.idTypeMeteo;
                    this.payload.couleur = this.meteoEvaluer.couleur;
                    this.payload.nbCriteres = this.meteoEvaluer.nbCriteres;
                    this.payload.score = this.meteoEvaluer.score;
                    this.couleurMeteo(this.payload.couleur);
                } else {
                    swal('Information!', 'L\'évaluation n\'a pas pu être bien faite.', 'warning');
                }
            })
            .catch((error) => {
                swal('Information!', 'Erreur lors de l\'évaluation de la météo : ' + error, 'error');
                console.error('Erreur lors du chargement des météos :', error);
            })
            .finally(() => {
                this.$loading(false);
            });
        },
        couleurMeteo(value){
            switch (value) {
                case 'Noir':
                    return '#000000';
                case 'Orange':
                    return '#FFC000';
                case 'Rouge':
                    return '#FF0000';
                case 'Vert':
                    return '#00B050';
                case 'Bleu':
                    return '#4472C4';
                case 'Blanc':
                    return '#FFFFFF';
                default:
                    return '#FFFFFF';
            }
        },
        couleurCritere(value){
            if(parseInt(value) >= 3){
                return '#00B050';
            }else if(parseInt(value) >= 2 && parseInt(value) < 3){
                return '#FFC000';
            }else if(parseInt(value) >= 1 && parseInt(value) < 2){
                return '#FF0000';
            }else if(parseInt(value) < 1){
                return '#000000';
            }else {
                return '#FFFFFF';
            }
        },
        selectComposante(item) {
            this.$loading(true);
            this.payload.idComposante = item;
            this.$loading(false);
        },
        checkValidationLiquidation(item, index) {
            const indexValeur = this.listIdValidation.indexOf(item.id);
            if (indexValeur === -1) {
                console.log("checkerrrr")
                this.listIdValidation.push(item.id)
            } else {
                this.listIdValidation.splice(indexValeur, item.id);
            }
            console.log(this.listIdValidation)
        },
        validationMeteo(listIdValidation){
            console.log(listIdValidation);
            const self = this;
            swal({
                title: "Confirmation",
                text: "Etes-vous sûr de vouloir valider ces météos ?",
                type: "warning",
                showCancelButton: true,
                closeOnConfirm: false,
                cancelButtonText: "Annuler",
                confirmButtonText: "Valider",
                confirmButtonColor: "#7db0b2",
                cancelButtonColor: "#FF0000",
                showLoaderOnConfirm: true
            }, function(result) {
                if (result === true) {
                    self.$loading(true);
                    self.$http.post('/meteo/validateMeteo', listIdValidation)
                    .then(({data}) => {
                        if (data) {
                            swal('Information!', 'La validation a bien été effectuée.', 'success');
                            self.onSearch();
                            self.listIdValidation = [];
                            self.runCheck(0);
                            //self.window.location.reload();
                        } else {
                            swal('Information!', 'La validation n\'a pas pu être effectuée.', 'warning');
                        }
                    })
                    .catch((error) => {
                        swal('Information!', 'Une erreur est survenue lors de la validation. ' + error, 'error');
                        console.error('Une erreur est survenue lors de la validation :', error);
                    })
                    .finally(() => {
                        self.$loading(false);
                    })
                }
            });
        },
        runCheck(id, event){
            this.$loading(true);
            switch (id) {
                case 0:
                    this.$http.get(`/meteo/notValidated`)
                    .then(({data}) =>{
                        if (data) {
                            this.items = data;
                            this.lesmeteos = data?.content;
                        } else {
                            this.lesmeteos = [];
                            swal('Information!', 'Aucune météo à valider disponible.', 'warning');
                        }
                    })
                    .catch((error) => {
                        swal('Information!', 'Erreur lors de la récupération des météos à valider : ' + error, 'error');
                        console.error('Erreur lors du chargement des météos :', error);
                    })
                    .finally(() => {
                        this.$loading(false);
                    });
                break;
                case 1:
                this.$http.get(`/meteo/notValidated`)
                    .then(({data}) =>{
                        if (data.length > 0) {
                            this.lesmeteos = data;
                        } else {
                            this.lesmeteos = [];
                            swal('Information!', 'Aucune météo à valider disponible.', 'warning');
                        }
                    })
                    .catch((error) => {
                        swal('Information!', 'Erreur lors de la récupération des météos à valider : ' + error, 'error');
                        console.error('Erreur lors du chargement des météos :', error);
                    })
                    .finally(() => {
                        this.$loading(false);
                    });
                break;
                case 2:
                this.$http.get(`/meteo/validated`)
                    .then(({data}) =>{
                        if (data.length > 0) {
                            this.lesmeteos = data;
                        } else {
                            this.lesmeteos = [];
                            swal('Information!', 'Aucune météo validée disponible.', 'warning');
                        }
                    })
                    .catch((error) => {
                        swal('Information!', 'Erreur lors de la récupération des météos validées : ' + error, 'error');
                        console.error('Erreur lors du chargement des météos :', error);
                    })
                    .finally(() => {
                        this.$loading(false);
                    });
                break;
            
                default:
                this.onSearch();
                break;
            }
        },
    },
    created() {
        this.onSearch();
        this.$http.get('/composantes/all')
            .then(({data}) =>{
                this.composantes = data;
            });
        this.$http.get('/etatComposante')
        .then(({data}) =>{
            this.etatComposantes = data;
        });
    }
}
</script>

<style>

</style>